import React from "react";
// import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

const Placeholder = props => {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
};

export default Placeholder;
